import {getKeyTitle} from "../js/tool";

export const guestTypeList = [
    {key: 1, title: '嘉宾'},
    {key: 2, title: '随行人员'},
]

export const genderList = [
    {key: 1, title: '男'},
    {key: 2, title: '女'},
]

export const guestWayTypeList = [
    {key: 1, title: '高铁'},
    {key: 2, title: '飞机'},
    {key: 3, title: '自驾'},
    {key: 4, title: '其他'},
]

export const guestIdTypeList = [
    {key: 1, title: '身份证'},
    {key: 2, title: '护照'},
]

export const guestAuditStatusList = [
    {key: 1, title: '未审核'},
    {key: 2, title: '已审核'},
]

export const getGuestTypeText = function (type) {
    return getKeyTitle(guestTypeList, type);
}

export const getGenderText = function (gender) {
    return getKeyTitle(genderList, gender);
}

export const getIdTypeText = function (type) {
    return getKeyTitle(guestIdTypeList, type);
}

export const getWayTypeText = function (type) {
    return getKeyTitle(guestWayTypeList, type);
}

export const getGuestAuditStatusText = function (status) {
    return getKeyTitle(guestAuditStatusList, status);
}

export const getNeedText = function (type) {
    return type == 1 ? '需要' : '不需要';
}
